<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Cookies from '@/utils/Cookies'

export default {
  name: 'App',
  data () {
    return {
      page: { title: 'Digible CMS' }
    }
  },
  computed: {
    getRouteParams () {
      const { type, page, id } = this.$route.params
      return { type, page, id }
    },

    getUserData () {
      return this.$store.state.userData
    },

    getRouteName () {
      return this.$route.name
    }
  },
  metaInfo () {
    return {
      title: this.page.title
    }
  },
  watch: {
    $route (to, from) {
      this.checkUserLogged()
      this.checkUserProfile()
    }
  },
  methods: {
    checkUserLogged () {
      if (
        !this.getUserData &&
        (
          this.getRouteName !== 'Logout' &&
          this.getRouteName !== 'Login' &&
          this.getRouteName !== 'ForgotPassword'
        )
      ) {
        this.$router.push({ name: 'Login' })
      }
    },
    checkUserProfile () {
      if (this.getUserData) {
        // 'Leitor' profile
        if (this.getUserData.level_access === 1 && this.getRouteParams.type === 'cadastrar') {
          this.$router.push({ name: 'Page401' })
        }

        // admin access
        if (
          this.getUserData.level_access !== 3 &&
          (
            this.getRouteName === 'Carriers' ||
            this.getRouteName === 'Users' ||
            this.getRouteName === 'JobsFaq' ||
            this.getRouteName === 'JobsFaqCarrier' ||
            this.getRouteName === 'JobsFaqItem' ||
            this.getRouteName === 'JobsTerms'
          )
        ) {
          this.$router.push({ name: 'Page401' })
        }

        /**
         * ==============================
         * PRODUCT ID
         * ==============================
         * 1 => Empregos
         * 2 => Viagens
         * 3 => Fashion
         * 8 => Saúde
         */

        /**
         * ==============================
         * PROFILE ID
         * ==============================
         * 1 => Leitor
         * 2 => Editor
         * 3 => Administrador
         */

        const productId = this.getUserData.product_access.map(item => item.id)

        // 'Editor' and 'Leitor' profile
        if (this.getUserData.level_access !== 3) {
          // jobs vertical
          if ((/^Jobs.*/.test(this.getRouteName) && !productId.includes(1))) {
            this.$router.push({ name: 'Page401' })
          }
        }
      }
    }
  },
  beforeCreate () {
    if (!this.getUserData) {
      this.$store.commit('userData', JSON.parse(Cookies.get('cms-gold360')))
    }
  },
  created () {
    this.checkUserLogged()
    this.checkUserProfile()
  },
  mounted () {
    $('body').tooltip({
      selector: '[data-toggle="tooltip"]'
    })
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/app.scss';

html, body, #app {
  height: 100%;
}

body {
  background-color: #f3f3f4;
  overflow-x: hidden;
  @include transition(background-color .1s);
}

.panel-main {
  background-color: #2f4050;
}
</style>



// WEBPACK FOOTER //
// src/App.vue